'use client'
import 'swiper/css'

import { Badge, Drawer, Flex, Box } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { usePathname } from 'next/navigation'
import type React from 'react'
import { useContext } from 'react'

import { IdentityContext, SafeImage, useAppAuth } from '~/app/_components'

import { AccountProfileCard } from '../AccountProfileCard'
import { AccountsFilterContext } from '../AccountsFilterContext'
import { ProfessionsFilterContext } from '../ProfessionsFilterContext'
import { SearchFilterMobile } from './SearchFilterMobile'
import { closeButton, filterTitle, mobileDrawerBody, mobileProfileAdjustmentIconBadgeLabel } from './styles.css'
import { TrimmedAccountFragment } from '~/generated/graphql'
import { mobileProjectsAdjustmentIcon, mobileProjectsAdjustmentIconLifted } from '~/app/iso/styles.css'

export function SearchResultPageOuterMobile({
  children,
}: {
  children: React.ReactNode
}) {
  const { freeTextSearch, locationSearch, accountTypeSearch } = useContext(AccountsFilterContext)
  const { professions } = useContext(ProfessionsFilterContext)
  // const height = useWindowHeight()

  const { currentAccount } = useContext(IdentityContext)
  const hasFolioItems = currentAccount?.folioItems?.length && currentAccount?.folioItems?.length > 0

  const pn = usePathname()
  const isOnMyContacts = pn.includes('/contacts')

  const [openedFilters, { open: openFilters, close: closeFilters }] = useDisclosure(false)

  function calcBadgeTruthy() {
    if (!professions.length && !freeTextSearch.length && !locationSearch.length && !accountTypeSearch.length) {
      return false
    }
    return true
  }

  function calcBadgeNumber() {
    let badgeNumber = professions.length + locationSearch.length + accountTypeSearch.length

    // Add 1 if freeTextSearch is not empty
    if (freeTextSearch) {
      badgeNumber += 1
    }

    return badgeNumber
  }

  const { isSignedIn, handleSignIn } = useAppAuth()
  function handleOpenFilter() {
    if (!isSignedIn) {
      handleSignIn()
    } else {
      openFilters()
    }
  }

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      style={{
        minHeight: 'calc(100vh - 70px - 62px)',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Box w="100%">
        {children}
        {!pn.includes('/start') ? (
          <Badge
            color="black"
            data-testid="open-filter-button"
            size="md"
            className={
              hasFolioItems || !currentAccount ? mobileProjectsAdjustmentIcon : mobileProjectsAdjustmentIconLifted
            }
            radius="md"
            leftSection={<SafeImage alt="" width={15} height={15} src={'/icons/filterIcon.webp'} />}
            rightSection={
              calcBadgeTruthy() ? (
                <Badge
                  size="md"
                  circle
                  style={{
                    position: 'relative',
                    left: '5px',
                    color: 'black',
                    zIndex: '100',
                  }}
                >
                  {calcBadgeNumber()}
                </Badge>
              ) : null
            }
            classNames={{ label: mobileProfileAdjustmentIconBadgeLabel }}
            onClick={handleOpenFilter}
          >
            FILTER
          </Badge>
        ) : null}
      </Box>

      <Drawer
        opened={openedFilters}
        onClose={closeFilters}
        closeButtonProps={{ size: 'xl' }}
        padding="0px"
        title={isOnMyContacts ? 'FILTER CONTACTS' : 'FILTER COMMUNITY'}
        classNames={{
          body: mobileDrawerBody,
          close: closeButton,
          title: filterTitle,
        }}
      >
        <SearchFilterMobile closeFilters={closeFilters} />
      </Drawer>
    </Flex>
  )
}

export function SearchResultPageInnerMobile({
  edges,
}: {
  edges: { node: TrimmedAccountFragment; cursor: string }[]
}) {
  return (
    <>
      {edges.map((edge) => (
        <AccountProfileCard account={edge.node} key={edge.cursor} />
      ))}
    </>
  )
}
